module.exports = __webpack_public_path__ + "img/middle_step2.bc2f48cc.png";